import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import '../../node_modules/lodash/_Stack.js';
import '../../node_modules/lodash/_SetCache.js';
import '../../node_modules/lodash/_equalByTag.js';
import '../../node_modules/lodash/isArguments.js';
import '../../node_modules/lodash/isBuffer.js';
import '../../node_modules/lodash/isTypedArray.js';
import '../../node_modules/lodash/_baseGetTag.js';
import '../../node_modules/lodash/_getTag.js';
import '../provider/WindowSizeContext.js';
import '../provider/ColorModeContext.js';
import { useColorModeValue } from '../../hooks/useColorModeValue.js';
import styled from 'styled-components';
import { borderRadius } from '../../node_modules/styled-system/dist/index.esm.js';
import { Spinner } from '../spinner/Spinner.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { compose } from '../../node_modules/@styled-system/core/dist/index.esm.js';
import { typography } from '../../node_modules/@styled-system/typography/dist/index.esm.js';
import { position } from '../../node_modules/@styled-system/position/dist/index.esm.js';
import { shadow } from '../../node_modules/@styled-system/shadow/dist/index.esm.js';
import { layout } from '../../node_modules/@styled-system/layout/dist/index.esm.js';
var ButtonIcon = styled.span({
  display: "inline-flex",
  alignSelf: "center",
  fontSize: "20px",
  flexShrink: 0,
  color: "inherit"
}, space);
var sizeVariants = {
  xxs: {
    height: "24px",
    minWidth: "24px",
    borderRadius: "8px",
    paddingX: "12px",
    fontSize: "label.xs",
    lineHeight: "label.xs"
  },
  xs: {
    height: "36px",
    minWidth: "36px",
    borderRadius: "12px",
    paddingX: "16px",
    fontSize: "label.sm",
    lineHeight: "label.sm"
  },
  sm: {
    height: "40px",
    minWidth: "40px",
    borderRadius: "12px",
    paddingX: "16px",
    fontSize: "label.md",
    lineHeight: "label.md"
  },
  md: {
    height: "48px",
    minWidth: "48px",
    borderRadius: "16px",
    paddingX: "16px",
    fontSize: "label.md",
    lineHeight: "label.md"
  },
  lg: {
    height: "56px",
    minWidth: "56px",
    borderRadius: "16px",
    paddingX: "24px",
    fontSize: "label.md",
    lineHeight: "label.md"
  },
  xl: {
    height: "64px",
    minWidth: "64px",
    borderRadius: "16px",
    paddingX: "24px",
    fontSize: "heading.md",
    lineHeight: "heading.md"
  }
};
var StyledButton = styled.button(variant({
  prop: "size",
  variants: sizeVariants
}), variant({
  variants: {
    primary: {
      backgroundColor: "brand",
      borderColor: "brand",
      color: "white",
      ":hover": {
        backgroundColor: "green.400",
        borderColor: "green.400"
      },
      ":disabled": {
        backgroundColor: "grey.6",
        borderColor: "grey.6",
        color: "grey.10"
      }
    },
    secondary: {
      backgroundColor: "grey.4",
      borderColor: "grey.4",
      color: "textPrimary",
      ":hover": {
        backgroundColor: "grey.7",
        borderColor: "grey.7"
      },
      ":disabled": {
        backgroundColor: "grey.6",
        borderColor: "grey.6",
        color: "grey.10"
      }
    },
    secondaryBg: {
      backgroundColor: "grey.7",
      borderColor: "grey.7",
      color: "textPrimary",
      ":hover": {
        backgroundColor: "grey.8",
        borderColor: "grey.8"
      },
      ":disabled": {
        backgroundColor: "grey.6",
        borderColor: "grey.6",
        color: "grey.10"
      }
    },
    ghost: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      ":hover": {
        backgroundColor: "grey.8",
        borderColor: "grey.8"
      },
      ":disabled": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        color: "grey.10"
      }
    }
  }
}), function (_a) {
  var isFullWidth = _a.isFullWidth;
  return css({
    boxSizing: "border-box",
    appearance: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 250ms, transform 0.1s ease-in-out",
    userSelect: "none",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    outline: "none",
    width: isFullWidth ? "100%" : undefined,
    fontWeight: "600",
    fontFamily: "matter",
    letterSpacing: "sm",
    borderWidth: "2px",
    cursor: "pointer",
    borderStyle: "solid",
    ":active": {
      transform: "scale(0.95)"
    },
    ":disabled": {
      cursor: "not-allowed"
    }
  });
}, function (_a) {
  var colorScheme = _a.colorScheme;
  if (colorScheme) {
    if (colorScheme === "white") {
      return css({
        backgroundColor: "white",
        borderColor: "white",
        color: "grey.9",
        ":hover": {
          backgroundColor: "grey.7",
          borderColor: "grey.7",
          color: "textPrimary"
        },
        ":disabled": {
          backgroundColor: "grey.6",
          borderColor: "grey.6",
          color: "grey.10"
        }
      });
    }
    var color = "".concat(colorScheme, ".300");
    var hover = "".concat(colorScheme, ".400");
    return css({
      backgroundColor: color,
      borderColor: color,
      color: "white",
      ":hover": {
        backgroundColor: hover,
        borderColor: hover
      },
      ":disabled": {
        backgroundColor: "grey.6",
        borderColor: "grey.6",
        color: "grey.10"
      }
    });
  }
  return {};
}, compose(space, typography, position, shadow, borderRadius, layout));
var UpdatedButton = React__default.forwardRef(function (_a, ref) {
  var isLoading = _a.isLoading,
    size = _a.size,
    variant = _a.variant,
    isDisabled = _a.isDisabled,
    _b = _a.isRounded,
    isRounded = _b === void 0 ? true : _b,
    _c = _a.type,
    type = _c === void 0 ? "button" : _c,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    children = _a.children,
    rest = __rest(_a, ["isLoading", "size", "variant", "isDisabled", "isRounded", "type", "leftIcon", "rightIcon", "children"]);
  var secondaryBgVariant = useColorModeValue("secondary", "secondaryBg");
  var getVariant = function getVariant() {
    if (variant === "secondaryBg") return secondaryBgVariant;
    return variant || "primary";
  };
  return React__default.createElement(StyledButton, __assign({
    type: type,
    disabled: isDisabled || isLoading,
    borderRadius: isRounded ? "64px" : undefined,
    size: size || "md",
    variant: getVariant(),
    paddingX: isLoading ? "0px" : undefined
  }, rest, {
    ref: ref
  }), leftIcon && !isLoading && React__default.createElement(ButtonIcon, {
    mr: "6px"
  }, leftIcon), isLoading ? React__default.createElement(Spinner, {
    color: "white"
  }) : children, rightIcon && !isLoading && React__default.createElement(ButtonIcon, {
    ml: "6px"
  }, rightIcon));
});
export { UpdatedButton };